import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images, index, onClose, onPrev, onNext }) => {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowLeft") onPrev();
            if (e.key === "ArrowRight") onNext();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose, onPrev, onNext]);

    if (index === null || index === undefined) return null;
    const img = images[index];

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25 }}
                data-testid="lightbox"
                className="fixed inset-0 z-[80] bg-[#0E0E0D]/95 backdrop-blur-sm flex flex-col"
                onClick={onClose}
            >
                <div className="flex items-center justify-between p-5 md:p-8 text-[#FAF9F6]">
                    <div className="overline text-[#C7B299]">
                        {String(index + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
                    </div>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                        data-testid="lightbox-close"
                        className="p-2 hover:text-[#C7B299] transition-colors"
                        aria-label="Close"
                    >
                        <X size={24} strokeWidth={1.4} />
                    </button>
                </div>

                <div
                    className="flex-1 flex items-center justify-center px-4 md:px-16 pb-4"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        onClick={onPrev}
                        data-testid="lightbox-prev"
                        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-[#FAF9F6]/30 text-[#FAF9F6] hover:bg-[#FAF9F6] hover:text-[#0E0E0D] transition-colors flex items-center justify-center"
                        aria-label="Previous"
                    >
                        <ChevronLeft size={20} strokeWidth={1.5} />
                    </button>

                    <motion.img
                        key={img.src}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                        src={img.src}
                        alt={img.caption}
                        className="max-h-[75vh] max-w-full object-contain"
                    />

                    <button
                        onClick={onNext}
                        data-testid="lightbox-next"
                        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 border border-[#FAF9F6]/30 text-[#FAF9F6] hover:bg-[#FAF9F6] hover:text-[#0E0E0D] transition-colors flex items-center justify-center"
                        aria-label="Next"
                    >
                        <ChevronRight size={20} strokeWidth={1.5} />
                    </button>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};
